import { Fragment, useContext, useState } from "react";
import { Disclosure, Menu, Transition } from "@headlessui/react";
import { Bars3Icon, BellIcon, XMarkIcon } from "@heroicons/react/24/outline";
import AuthContext from "../AuthContext";
import { Link } from "react-router-dom";
import { useTheme } from "../ThemeContext"; // Import ThemeContext
import NotificationComponent from './Notification/ViewNotification'
const navigation = [
  { name: "Dashboard", href: "/", current: true },
  { name: "Users", href: "/Users", current: false },
  { name: "Project Management", href: "/Projects", current: false },
  { name: "Rfis", href: "/Rfis", current: false },
  { name: "Issues", href: "/Issues", current: false },
  { name: "Alerts", href: "/Alerts", current: false },
  { name: "Meetings", href: "/Meetings", current: false },
  { name: "QA", href: "/QA", current: false },
];

const userNavigation = [{ name: "Sign out", href: "./login" }];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Header() {
  const authContext = useContext(AuthContext);
  const { theme, toggleTheme } = useTheme(); // Access theme and toggle function
  const localStorageData = JSON.parse(localStorage.getItem("user"));
  const [showNotifications, setShowNotifications] = useState(false)

  return (
    <div className={`min-h-full bg-${theme}.bg text-${theme}.text`}>
      <Disclosure as="nav" className="bg-gray-800">
        {({ open }) => (
          <>
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
              <div className="flex h-16 items-center justify-between">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <div className="flex justify-center items-center gap-2">
                      <img
                        className="h-10 w-10"
                        src={require("../assets/login.png")}
                        alt="Civil"
                      />
                      <span className="font-bold italic">{`TC Engineering`}</span>
                    </div>
                  </div>
                </div>


                {/* Profile Dropdown */}
                <div className="hidden md:block">
                  <div className="ml-4 flex items-center md:ml-6">
                    <div className="relative">
                      <button
                        onClick={() => setShowNotifications(!showNotifications)}
                        className="rounded-full bg-gray-800 p-1 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
                      >
                        <span className="sr-only">View notifications</span>
                        <BellIcon className="h-6 w-6" aria-hidden="true" />
                      </button>
                      {showNotifications && (
                        <div className="absolute right-0 mt-2 w-96 bg-white rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
                          <NotificationComponent userName={localStorageData.name} />
                        </div>
                      )}
                    </div>
                    <button
                      type="button"
                      onClick={toggleTheme} // Toggle theme on button click
                      className="rounded-full bg-gray-800 p-1 text-gray-400 hover:text-white "
                    >
                      <span className="sr-only">Toggle theme</span>
                      {theme === 'light' ? '🌙' : '☀️'} {/* Icon for theme */}
                    </button>

                    {/* Profile dropdown */}
                    <Menu as="div" className="relative ml-3">
                      <div>
                        <Menu.Button className="flex max-w-xs items-center rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                          <span className="sr-only">Open user menu</span>
                          <p className="rounded-full w-8 text-xl h-8 bg-yellow-600 font-semibold text-gray-100 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-yellow-800">
                            {localStorageData ? localStorageData.name.charAt(0) : "User"}
                          </p>
                        </Menu.Button>
                      </div>

                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                          {userNavigation.map((item) => (
                            <Menu.Item key={item.name}>
                              {({ active }) => (
                                <Link
                                  to={item.href}
                                  className={classNames(
                                    active ? "bg-gray-100" : "",
                                    "block px-4 py-2 text-sm text-gray-700"
                                  )}
                                >

                                  <span onClick={() => authContext.signout()}>{item.name}</span>

                                </Link>
                              )}
                            </Menu.Item>
                          ))}
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  </div>
                </div>

                <div className="-mr-2 flex md:hidden">
                  <Disclosure.Button className="inline-flex items-center justify-center rounded-md bg-gray-800 p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                    <span className="sr-only">Open main menu</span>
                    {open ? (
                      <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                    ) : (
                      <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                    )}
                  </Disclosure.Button>
                </div>
              </div>
            </div>

            <Disclosure.Panel
              className={`fixed inset-0 left-0 top-0 z-20 w-3/4 max-w-xs bg-gray-800 p-4 transform transition-transform ${open ? "translate-x-0" : "-translate-x-full"
                } md:hidden`}
            >
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <div className="flex justify-center items-center gap-2">
                    <img
                      className="h-10 w-10"
                      src={require("../assets/login.png")}
                      alt="Civil"
                    />
                    <span className="font-bold italic">{`Civil Project`}</span>
                  </div>
                </div>
              </div>
              <div className="border-b border-gray-700 pt-4 pb-3">
                <div className="flex items-center px-5">

                  <div className="ml-3">

                    <div className="text-base flex justify-between w-full mb-3 font-medium leading-none text-white">
                      {localStorageData.name} <span >
                        <button
                          onClick={() => setShowNotifications(!showNotifications)}
                          className="rounded-full bg-gray-800 p-1 text-gray-400 hover:text-white "
                        >
                          <span className="sr-only">View notifications</span>
                          <BellIcon className="h-6 w-6" aria-hidden="true" />
                        </button>
                        {showNotifications && (
                          <div className="absolute right-0  bg-white rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
                            <NotificationComponent userName={localStorageData.name} />
                          </div>
                        )}</span>
                    </div>
                    <div className="text-sm font-medium leading-none mb-2 text-blue-400">
                      {localStorageData.email}
                    </div>

                  </div>
                </div>
              </div>

              <div className="space-y-1 pb-3 pt-2">

                {navigation.map((item) => (
                  <Link to={item.href} key={item.name}>
                    <Disclosure.Button
                      as="a"
                      className={classNames(
                        item.current
                          ? "bg-gray-900 text-white"
                          : "text-gray-300 hover:bg-gray-700 hover:text-white",
                        "block rounded-md px-3 py-2 text-base font-medium"
                      )}
                      aria-current={item.current ? "page" : undefined}
                    >
                      {item.name}
                    </Disclosure.Button>
                  </Link>
                ))}
              </div>
              <div className="border-t border-gray-700 pt-4 pb-3">

                <div className="mt-3 space-y-1">
                  {userNavigation.map((item) => (
                    <Disclosure.Button
                      key={item.name}
                      as="a"
                      href={item.href}
                      className="block rounded-md px-3 py-2 text-base font-medium text-gray-400 hover:bg-gray-700 hover:text-white"
                    >
                      {item.name}
                    </Disclosure.Button>
                  ))}
                </div>
              </div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </div>
  );
}
